module.exports = __webpack_public_path__ + "img/w_full_mockup.6f7a17da.png";